import { createContext, useContext } from 'react'

import { State } from './providers/TourProvider'
import { TOURS_CONFIGURATION } from '@/config/tours'

type TourContextType = {
  onGeneralStatusToggle: () => void
  onSingleTourToggle: (flag: boolean, tourKey: string) => void
  state: State
  tours: typeof TOURS_CONFIGURATION
}

export const TourContext = createContext<TourContextType>(undefined)

TourContext.displayName = 'TourContext'

export const useTourContext = () => useContext(TourContext)
